import { mutator } from 'satcheljs';
import {
    onActiveRetentionPoliciesListSucceeded,
    deleteRetentionPolicyRow,
    addRetentionPolicyRow,
    onAddActivePolicyTagsRequestComplete,
    onRetentionPoliciesFullInitialized,
} from '../actions/internalActions';
import { ObservableMap } from 'mobx';
import getActivePoliciesListState from '../selectors/getActivePoliciesListState';

mutator(onActiveRetentionPoliciesListSucceeded, actionMessage => {
    const { policies, policyRowIds } = actionMessage;
    const activePolicies = getActivePoliciesListState();
    activePolicies.retentionPolicies = new ObservableMap(policies);
    activePolicies.retentionPolicyIds = policyRowIds;
    // Since we have updated the policy data now with the latest values, update the isStale value
    activePolicies.isStale = false;
});

mutator(deleteRetentionPolicyRow, actionMessage => {
    const { retentionId, policyIndex } = actionMessage;
    const activePolicies = getActivePoliciesListState();
    activePolicies.retentionPolicies.delete(retentionId);
    activePolicies.retentionPolicyIds.splice(policyIndex, 1);
    activePolicies.isStale = true;
});

mutator(addRetentionPolicyRow, actionMessage => {
    const { policyRow, retentionId, policyIndex } = actionMessage;
    const activePolicies = getActivePoliciesListState();
    activePolicies.retentionPolicies.set(retentionId, policyRow);
    activePolicies.retentionPolicyIds.splice(policyIndex, 0, retentionId);
});

mutator(onAddActivePolicyTagsRequestComplete, () => {
    const activePolicies = getActivePoliciesListState();
    activePolicies.isStale = true;
});

mutator(onRetentionPoliciesFullInitialized, () => {
    const activePolicies = getActivePoliciesListState();
    activePolicies.isStale = true;
});
